<template>
  <div class="guest-login flex flex-col h-full h-screen items-center justify-center">
    <mj-spinner
      v-if="isBusy"
      :size="200"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {

  data() {
    return {
      isBusy: false,
    };
  },

  methods: {
    ...mapActions(['subUserLogin']),
    ...mapMutations(['clearLocalStorage']),
  },

  created() {
    const { token } = this.$route.params;
    if (token) {
      this.isBusy = true;
      this.subUserLogin({ token })
        .then(() => {
          this.clearLocalStorage();
          this.$router.push({ name: 'event.track.search' });
        })
        .catch(console.error)
        .finally(() => {
          this.isBusy = false;
        });
    }
  },
};

</script>
